export class InvestigationEmailTemplateSnapshotEntity {
  public id!: string;
  public name!: string;
  public subject!: string;
  public body!: string;
  public isActive!: boolean;
}
